import React from "react";
import { sendEvent } from "../../service/ragSearch";

function renderAnswerNodes(answer, citationsByN, onCitationClick) {
  const parts = String(answer).split(/(\[\d+\])/g);
  return parts.map((part, i) => {
    const match = part.match(/^\[(\d+)\]$/);
    if (match) {
      const n = Number(match[1]);
      const citation = citationsByN[n];
      return (
        <button
          key={i}
          type="button"
          onClick={() => citation && onCitationClick(citation)}
          className="align-super text-xs text-primaryBlue font-bold hover:underline"
        >
          {part}
        </button>
      );
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
}

export default function RagAnswerPanel({
  answer,
  citations,
  noAnswer,
  loading,
  requestId,
  onCitationClick,
}) {
  const list = citations || [];
  const citationsByN = list.reduce((acc, c) => {
    acc[c.n] = c;
    return acc;
  }, {});

  const sendFeedback = (feedback) => {
    if (requestId) sendEvent({ request_id: requestId, kind: "feedback", feedback });
  };

  return (
    <div className="rounded-lg border border-[#D2D6DC] p-4 mb-8">
      <div className="text-primaryDark leading-relaxed whitespace-pre-wrap">
        {renderAnswerNodes(answer, citationsByN, onCitationClick)}
        {loading && <span className="animate-pulse"> ▋</span>}
      </div>

      {!loading && (
        <>
          {list.length > 0 && (
            <ol className="mt-4 space-y-1 text-sm">
              {list.map((c) => (
                <li key={c.n}>
                  <button
                    type="button"
                    onClick={() => onCitationClick(c)}
                    className="text-primaryBlue hover:underline text-left"
                  >
                    [{c.n}] {c.title}
                  </button>
                  {c.summary && (
                    <div className="text-primaryDark opacity-70 ml-5">
                      {c.summary}
                    </div>
                  )}
                </li>
              ))}
            </ol>
          )}

          {!noAnswer && (
            <div className="mt-4 flex gap-4">
              <button type="button" aria-label="thumbs up" onClick={() => sendFeedback("up")}>
                👍
              </button>
              <button type="button" aria-label="thumbs down" onClick={() => sendFeedback("down")}>
                👎
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
